import { StreamActions } from '@hotwired/turbo'

StreamActions.page_reload = function () {
  window.location.reload()
}
